// helpers/resolveAvailableIntegrations.ts
import { IntegrationAvailabilityApi } from "../config/integrations.types";
import { normalizeIntegration } from "./normalizeIntegration";

export const EXCLUDED_INTEGRATIONS = ['shopify'];

/** Wildcard used in `integration_availabilities.allowed_countries` to mean "all countries". */
const ALL_COUNTRIES = "*";

export const resolveAvailableIntegrations = ({
  apiIntegrations,
  country,
}: {
  apiIntegrations: IntegrationAvailabilityApi[];
  country: string;
}) => {
  return apiIntegrations
    .map(normalizeIntegration)
    .filter((integration) => {
      const isExcluded = EXCLUDED_INTEGRATIONS.includes(integration.id);
      const isEnabled = integration.enabled;
      const isCountryAllowed =
        integration.allowedCountries.includes(ALL_COUNTRIES) ||
        integration.allowedCountries.includes(country);

      return !isExcluded && isEnabled && isCountryAllowed;
    });
};
